var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, } from 'react';
import { TableTestIdFactory } from '../../interactions';
import styles from './TBody.module.css';
export const TBody = ({ children, 'data-testid': testId, isScrollable = true, onScrollYChange, onTBodyScroll, tBodyRef, }) => {
    _react_refresh_temp_2();
    const localTBodyRef = useRef(null);
    const hasScrollRef = useRef(false);
    useEffect(() => {
        if (!onScrollYChange) {
            return;
        }
        const el = tBodyRef?.current || localTBodyRef.current;
        /**
         * Implementing resize observer, so that we can notify the Table
         * when it needs to add a vertical scrollbar on its THEad in the
         * WebKit browsers.
         * If needed elsewhere in future, we can extract the ResizeObserver
         * in a dedicated hook.
         */
        // TODO: https://lucidlink.atlassian.net/browse/LUCID-19094
        // Implement singleton ResizeObserver
        const observer = new ResizeObserver(() => {
            let hasScroll = false;
            if (el && el.scrollHeight > el.clientHeight) {
                hasScroll = true;
            }
            if (hasScrollRef.current !== hasScroll) {
                hasScrollRef.current = hasScroll;
                onScrollYChange(hasScroll);
            }
        });
        if (el) {
            observer.observe(el);
        }
        return () => {
            if (el) {
                observer.unobserve(el);
            }
        };
    }, [onScrollYChange, tBodyRef]);
    return (_jsx("tbody", { className: isScrollable ? styles.Container : '', "data-testid": TableTestIdFactory.getTableBodyTestId(testId), ref: tBodyRef, ...(onTBodyScroll && { onScroll: onTBodyScroll }), children: children }));
};
_react_refresh_temp_1 = TBody;
$RefreshReg$(_react_refresh_temp_1, "TBody");
_react_refresh_temp_2(TBody, "IEkWtFppxm+hy+1zgZeX7Id5xmo=");
